export default __webpack_public_path__ + "static/media/set_6_360-5.0f548a95.svg";